// Polyfill for Array.prototype.at function.
// Support for Safari <= 14 as an "temporary, exceptional" case
// Code from: https://github.com/tc39/proposal-relative-indexing-method#polyfill
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, 'at', {
    value: function (this: Array<any>, n: number) {
      // ToInteger() abstract op
      n = Math.trunc(n) || 0;
      // Allow negative indexing from the end
      if (n < 0) n += this.length;
      // OOB access is guaranteed to return undefined
      if (n < 0 || n >= this.length) return undefined;
      // Otherwise, this is just normal property access
      return this[n];
    },
  });
}
export {};
